export default {
  "loyaltyAdmin.workspaceAccessRequired": "Jūsu konts var skatīt šo tirgotāju, bet tam nav piekļuves lojalitātei. Lūdziet administratoram piešķirt lojalitātes lomu šim tirgotājam vai tā īpašniekam, pēc tam piesakieties vēlreiz. Maksājumu un finanšu tiesības piešķir atsevišķi.",
  "loyaltyAdmin.sourceTitle": "Lojalitātes avots un Syrve",
  "loyaltyAdmin.sourceScope": "Izmaiņas attiecas tikai uz izvēlēto tirgotāju.",
  "loyaltyAdmin.sourcePurpose": "Šeit izvēlas, vai maksājumos izmantot Syrve vai Coop lojalitāti. Lai izveidotu kategoriju vai izsniegtu karti, šie iestatījumi nav jāaizpilda.",
  "loyaltyAdmin.sourceChangeSettings": "Mainīt maksājumos izmantoto lojalitātes sistēmu",
  "loyaltyAdmin.sourceFinancial": "Finansiālais lojalitātes avots",
  "loyaltyAdmin.sourceSyrveIntegration": "Syrve lojalitātes integrācija",
  "loyaltyAdmin.sourceNative": "Coop lojalitāte",
  "loyaltyAdmin.sourceSyrve": "Syrve",
  "loyaltyAdmin.sourceEnabled": "Ieslēgta",
  "loyaltyAdmin.sourceDisabled": "Izslēgta",
  "loyaltyAdmin.sourceSeparateNotice": "Avota maiņa neizslēdz Syrve integrāciju.",
  "loyaltyAdmin.sourceAction": "Maināmais iestatījums",
  "loyaltyAdmin.sourceTarget": "Jaunais finansiālais avots",
  "loyaltyAdmin.sourceIntegrationTarget": "Jaunais Syrve integrācijas stāvoklis",
  "loyaltyAdmin.sourceReason": "Avota vai integrācijas maiņas iemesls",
  "loyaltyAdmin.sourceReconciliation": "Saskaņošanas un gatavības apstiprinājums",
  "loyaltyAdmin.sourceRollback": "Atcelšanas plāns",
  "loyaltyAdmin.sourceConsequences": "Pirms maiņas apturiet jaunas lojalitātes darbības, pabeidziet aktīvās vizītes un saskaņojiet nepabeigtos maksājumus un atlikumus. Esošie atlikumi un vēsture saglabājas. Citas POS funkcijas netiek ietekmētas.",
  "loyaltyAdmin.sourceApply": "Piemērot šīs administratīvās izmaiņas",
  "loyaltyAdmin.sourceRetry": "Atkārtot saglabātās administratīvās izmaiņas",
  "loyaltyAdmin.sourceApplied": "Administratīvās izmaiņas apstiprinātas un ierakstītas žurnālā.",
  "loyaltyAdmin.sourcePendingWork": "Pašreizējais iestatījums saglabāts. Pirms maiņas pabeidziet aktīvās vizītes un saskaņojiet nepabeigtos maksājumus vai lojalitātes darbības.",
  "loyaltyAdmin.sourceNativeUnavailable": "Coop norēķini nav gatavi konfigurētajiem POS maršrutiem. Pašreizējais avots saglabāts.",
  "loyaltyAdmin.sourceAdapterRequired": "Pirms Syrve izvēles par finansiālo avotu ieslēdziet Syrve lojalitātes integrāciju ar atsevišķu darbību.",
  "loyaltyAdmin.sourceRevisionChanged": "Iestatījumi ir mainījušies. Atjaunojiet tos un vēlreiz pārskatiet pieprasītās izmaiņas.",
  "loyaltyAdmin.sourceResultUnknown": "Rezultāts nav apstiprināts. Pirms jaunām izmaiņām atkārtojiet to pašu saglabāto komandu.",
  "loyaltyAdmin.sourceEditRejected": "Pārskatīt noraidītās izmaiņas",
  "loyaltyAdmin.sourceInvalidSaved": "Saglabātās administratīvās izmaiņas nevar atjaunot. Lūdziet administratoram pārbaudīt rezultātu.",
  "loyaltyAdmin.giftFundingTitle": "Dāvanu karte par maksu",
  "loyaltyAdmin.giftFundingNotice": "Izvēlieties neapmaksātu Gift rēķinu, pieņemiet maksājumu un pārbaudiet rezultātu.",
  "loyaltyAdmin.giftFundingDisabled": "Šim tirgotājam maksas dāvanu karšu finansēšana nav pieejama.",
  "loyaltyAdmin.giftFundingKind": "Dāvanu kartes darbība",
  "loyaltyAdmin.giftSale": "Izsniegt pēc apmaksas",
  "loyaltyAdmin.giftTopup": "Maksas papildināšana",
  "loyaltyAdmin.giftInvoice": "Rēķins dāvanu kartes vērtībai",
  "loyaltyAdmin.giftSelectInvoice": "Izvēlieties neapmaksātu rēķinu",
  "loyaltyAdmin.giftUnnumberedInvoice": "Rēķins bez numura",
  "loyaltyAdmin.giftSavedInvoice": "Iepriekš izvēlētais rēķins",
  "loyaltyAdmin.giftRefreshInvoices": "Atjaunot rēķinus",
  "loyaltyAdmin.giftNoInvoices": "Nav piemērota neapmaksāta rēķina. Izveidojiet atsevišķu rēķinu dāvanu kartes vērtībai parastajā pasūtījumu plūsmā.",
  "loyaltyAdmin.giftReason": "Dāvanu kartes finansēšanas iemesls",
  "loyaltyAdmin.giftPrepare": "Sagatavot dāvanu kartes maksājumu",
  "loyaltyAdmin.giftRetryPreparation": "Atkārtot to pašu sagatavošanu",
  "loyaltyAdmin.giftAwaitingPayment": "Gaida pilnu apmaksu un izsniegtu čeku:",
  "loyaltyAdmin.giftRefreshResult": "Pārbaudīt maksājumu un dāvanu kartes rezultātu",
  "loyaltyAdmin.giftCancelNotice": "Sagatavošanu var atcelt tikai pēc servera apstiprinājuma, ka maksājums nav sākts. Nezināms bankas rezultāts paliek gaidīšanā.",
  "loyaltyAdmin.giftCancelReason": "Sagatavošanas atcelšanas iemesls",
  "loyaltyAdmin.giftCancelPreparation": "Atcelt sagatavošanu, ja maksājums nav sākts",
  "loyaltyAdmin.giftCanceled": "Sagatavošana atcelta. Dāvanu kartes vērtība nav ieskaitīta.",
  "loyaltyAdmin.giftCanceling": "Atcelšana tiek pārbaudīta. Saglabājiet šo mēģinājumu līdz rezultāta apstiprināšanai.",
  "loyaltyAdmin.giftCompleted": "Dāvanu kartes vērtība ieskaitīta:",
  "loyaltyAdmin.reservedValue": "Rezervētā vērtība",
  "loyaltyAdmin.giftAvailable": "Pieejamā vērtība:",
  "loyaltyAdmin.giftValueExpires": "Šīs iegādātās vērtības termiņš:",
  "loyaltyAdmin.giftNext": "Sākt citu dāvanu kartes darbību",
  "loyaltyAdmin.giftRecoverNotice": "Saglabāto mēģinājumu nevar nolasīt. Atkārtojiet to pašu sagatavošanu vai pārbaudiet rezultātu; neiekasējiet maksājumu vēlreiz.",
  "loyaltyAdmin.giftOperationPending": "Rezultāts nav apstiprināts. Saglabājiet šo mēģinājumu un pārbaudiet vēlreiz. Atkārtotai papildināšanai vēlreiz uzrādiet to pašu kartes kodu.",
  "loyaltyAdmin.giftInvalidRecovery": "Saglabātos dāvanu kartes datus nevar droši atjaunot. Pirms jaunas darbības lūdziet administratoram pārbaudīt esošo.",
  "loyaltyAdmin.gift": "Dāvanu karte",
  "loyaltyAdmin.giftMonths": "Iegādātās vērtības termiņš, mēneši",
  "loyaltyAdmin.giftPaidOnly": "Karte tiek izsniegta tukša. Vērtību pievieno atsevišķi.",
  "loyaltyAdmin.creditGiftAmount": "Pievienojamā dāvanu summa",
  "loyaltyAdmin.manualGiftCredit": "Pievienot dāvanu vērtību",
  "loyaltyAdmin.giftCredited": "Dāvanu vērtība pievienota",
  "loyaltyAdmin.manualGiftNotice": "Manuāls papildinājums bez maksājuma.",

  "loyaltyAdmin.systemAuthor": "Sistēma",
  "loyaltyAdmin.workspaceIntro": "Dāvanu, uzkrājumu un atlaižu kartes",
  "loyaltyAdmin.sessionChanged": "Sesija mainīta. Pirms turpināšanas pārlādējiet lapu.",
  "loyaltyAdmin.ownerChanged": "Tirgotāja īpašnieks mainījies. Pārlādējiet lapu un pārbaudiet pašreizējo programmu.",
  "loyaltyAdmin.cardQr": "Lojalitātes kartes QR kods",
  "loyaltyAdmin.downloadCardQr": "Saglabāt kartes QR",
  "loyaltyAdmin.findCard": "Atrast karti",
  "loyaltyAdmin.cardCode": "Precīzs kartes kods",
  "loyaltyAdmin.exactCodeNotice": "Noskenējiet vai ievadiet pilnu kartes kodu.",
  "loyaltyAdmin.scanCard": "Skenēt karti",
  "loyaltyAdmin.closeCamera": "Aizvērt kameru",
  "loyaltyAdmin.cameraStarting": "Kameras palaišana…",
  "loyaltyAdmin.cameraUnavailable": "Kamera nav pieejama. Atļaujiet piekļuvi kamerai vai ievadiet kodu manuāli.",
  "loyaltyAdmin.cardLookupFailed": "Karte nav atrasta vai nav pieejama. Pārbaudiet tirgotāju un precīzu kodu.",
  "loyaltyAdmin.recoveryUnavailable": "Papildinājumu darbības pašlaik ir atspējotas. Saglabātais pieprasījums tiek saglabāts saskaņošanai.",
  "loyaltyAdmin.invalidRecovery": "Saglabāto pieprasījumu nevar droši nolasīt. Jauni papildinājumi ir bloķēti līdz faktiskā rezultāta saskaņošanai.",
  "loyaltyAdmin.coreFinanceTitle": "Vietējo karšu finanses",
  "loyaltyAdmin.issuerOnlyNotice": "Šeit redzamas tikai šī tirgotāja izdotās kartes.",
  "loyaltyAdmin.checkResult": "Pārbaudīt rezultātu",
  "loyaltyAdmin.cancelPendingCredit": "Atcelt neiegrāmatotu papildinājumu",
  "loyaltyAdmin.retryCancel": "Atkārtot atcelšanu",
  "loyaltyAdmin.cancelledCredit": "Papildinājums atcelts; punkti nav pievienoti.",
  "loyaltyAdmin.committedAwaitingCore": "Papildinājums iegrāmatots. Saskaņošana ar Core vēl nav pabeigta; sākotnējais pieprasījums ir saglabāts.",
  "loyaltyAdmin.abortedAwaitingCore": "Atcelšana reģistrēta. Saskaņošana ar Core vēl nav pabeigta.",
  "loyaltyAdmin.pendingCredit": "Darbība vēl nav pabeigta. Jauns pieprasījums nav izveidots.",
  "loyaltyAdmin.financeUnavailable": "Finanšu dati īslaicīgi nav pieejami. Saglabāto pieprasījumu var atkārtot.",

  "loyaltyAdmin.title": "Lojalitātes kartes",
  "loyaltyAdmin.notice":
    "Šīs kartes vēl nav pieejamas maksājumiem. Esošā Syrve lojalitāte turpina darboties.",
  "loyaltyAdmin.merchant": "Tirgotājs",
  "loyaltyAdmin.selectMerchant": "Izvēlieties tirgotāju",
  "loyaltyAdmin.loadError": "Neizdevās ielādēt tirgotājus.",
  "loyaltyAdmin.disabled":
    "Pašu lojalitātes pārvaldība šajā vidē vēl nav ieslēgta.",
  "loyaltyAdmin.forbidden": "Jums nav tiesību veikt šo darbību.",
  "loyaltyAdmin.changed":
    "Dati ir mainījušies. Pirms atkārtošanas atjaunojiet un pārbaudiet tos.",
  "loyaltyAdmin.conflict":
    "Šī pieprasījuma atslēga jau izmantota citai darbībai.",
  "loyaltyAdmin.requestError":
    "Pieprasījums neizdevās. Atjaunojiet datus vai atkārtojiet saglabāto pieprasījumu.",
  "loyaltyAdmin.storageRequired":
    "Lai droši atkārtotu pieprasījumu, atļaujiet sesijas datu glabāšanu.",
  "loyaltyAdmin.invalid":
    "Pārbaudiet procentus, punkta vērtību un derīguma termiņu.",
  "loyaltyAdmin.refresh": "Atjaunot",
  "loyaltyAdmin.uncertain":
    "Rezultāts nav apstiprināts. Atkārtojiet to pašu pieprasījumu, lai neradītu dublikātu.",
  "loyaltyAdmin.retry": "Atkārtot saglabāto pieprasījumu",
  "loyaltyAdmin.issued": "Karte izsniegta",
  "loyaltyAdmin.bearerWarning":
    "Glabājiet numuru droši: uzrādītāja režīmā tas dod tiesības tērēt. Nepublicējiet to.",
  "loyaltyAdmin.hide": "Paslēpt numuru",
  "loyaltyAdmin.categories": "Kategorijas",
  "loyaltyAdmin.version": "Versija",
  "loyaltyAdmin.edit": "Mainīt",
  "loyaltyAdmin.history": "Noteikumu vēsture",
  "loyaltyAdmin.reason": "Izmaiņu vai izsniegšanas iemesls",
  "loyaltyAdmin.issueReason": "Kartes izsniegšanas iemesls",
  "loyaltyAdmin.companionCategory": "Otra kategorija (neobligāti)",
  "loyaltyAdmin.singleCategory": "Bez otras kategorijas",
  "loyaltyAdmin.blockReason": "Bloķēšanas vai atbloķēšanas iemesls",
  "loyaltyAdmin.newVersion": "Jauna noteikumu versija",
  "loyaltyAdmin.newCategory": "Jauna kategorija",
  "loyaltyAdmin.createCategory": "Izveidot kategoriju",
  "loyaltyAdmin.resetCategory": "Notīrīt kategorijas formu",
  "loyaltyAdmin.reasonRequired": "Norādiet iemeslu.",
  "loyaltyAdmin.versionNotice":
    "Izsniegtajām kartēm saglabājas sākotnējie noteikumi.",
  "loyaltyAdmin.name": "Nosaukums",
  "loyaltyAdmin.kind": "Veids",
  "loyaltyAdmin.accumulation": "Uzkrājumu",
  "loyaltyAdmin.discount": "Atlaižu",
  "loyaltyAdmin.rate": "Likme, %",
  "loyaltyAdmin.limit": "Apmaksas ar punktiem limits, %",
  "loyaltyAdmin.pointRate": "1 punkta vērtība",
  "loyaltyAdmin.months": "Uzkrājuma termiņš mēnešos",
  "loyaltyAdmin.confirmation": "Tērēšanas apstiprinājums",
  "loyaltyAdmin.BEARER": "Uzrādītājs",
  "loyaltyAdmin.PIN": "PIN",
  "loyaltyAdmin.SMS": "SMS",
  "loyaltyAdmin.ACCOUNT": "Viesa konts",
  "loyaltyAdmin.DYNAMIC_QR": "Vienreizējs QR",
  "loyaltyAdmin.excludeAccrual": "Neuzkrāt par",
  "loyaltyAdmin.excludeDiscount": "Nepiemērot atlaidi",
  "loyaltyAdmin.excludeRedemption": "Neapmaksāt ar punktiem",
  "loyaltyAdmin.removedCategory":
    "Dzēsta preču kategorija — pārbaudiet izņēmumu",
  "loyaltyAdmin.save": "Saglabāt versiju",
  "loyaltyAdmin.issue": "Izsniegt karti",
  "loyaltyAdmin.category": "Kategorija",
  "loyaltyAdmin.selectCategory": "Izvēlieties kategoriju",
  "loyaltyAdmin.more": "Ielādēt vēl",
  "loyaltyAdmin.cards": "Kartes",
  "loyaltyAdmin.blocked": "Bloķēta",
  "loyaltyAdmin.active": "Aktīva",
  "loyaltyAdmin.unblock": "Atbloķēt",
  "loyaltyAdmin.block": "Bloķēt",
  "loyaltyAdmin.financeTitle": "Coop atlikums un operācijas",
  "loyaltyAdmin.selectCard": "Izvēlieties karti",
  "loyaltyAdmin.pendingCard": "Karte ar nepabeigtu pieprasījumu",
  "loyaltyAdmin.balance": "Atlikums",
  "loyaltyAdmin.available": "Pieejamie punkti",
  "loyaltyAdmin.reserved": "Rezervētie punkti",
  "loyaltyAdmin.creditPoints": "Pievienojamie punkti",
  "loyaltyAdmin.expiryOverride": "Mainīt derīguma datumu",
  "loyaltyAdmin.expiryHint": "Tukšs lauks izmanto kartes termiņu. Izvēlētais datums beidzas 23:59 UTC",
  "loyaltyAdmin.monthsUnit": "mēn.",
  "loyaltyAdmin.overrideReason": "Termiņa maiņas iemesls",
  "loyaltyAdmin.manualCredit": "Pievienot punktus",
  "loyaltyAdmin.operations": "Operācijas",
  "loyaltyAdmin.author": "Autors",
  "loyaltyAdmin.standardExpiry": "Standarta termiņš",
  "loyaltyAdmin.selectedExpiry": "Izvēlētais termiņš",
  "loyaltyAdmin.credited": "Punkti pievienoti",
  "loyaltyAdmin.creditReceiptTitle": "Apstiprināts papildinājums",
  "loyaltyAdmin.newBalance": "Jaunais atlikums",
  "loyaltyAdmin.minorUnits": "mazākās vienības",
  "loyaltyAdmin.creditReceiptUnavailable": "Papildinājums ir apstiprināts, bet daļu precīzās kvīts informācijas neizdevās ielādēt. Trūkstošais atlikums vai termiņš netiek pieņemts pēc noklusējuma.",
  "loyaltyAdmin.retryReceipt": "Ielādēt kvīts informāciju",
  "loyaltyAdmin.financeRecovery": "Pieprasījuma rezultāts nav zināms. Pirms jaunas operācijas atkārtojiet šo pieprasījumu.",
  "loyaltyAdmin.financeChanged": "Atlikums mainījies. Atjaunojiet datus un pārbaudiet summu.",
  "loyaltyAdmin.financeValidation": "Norādiet pozitīvu summu atbilstoši punktu kursam, iemeslu un nākotnes datumu ar maiņas iemeslu.",
  "loyaltyAdmin.pointsUnit": "punkti",
  "loyaltyAdmin.refreshBalance": "Atjaunot atlikumu",
  "loyaltyAdmin.operationCREDIT": "Uzkrājums",
  "loyaltyAdmin.operationRESERVE": "Rezervācija",
  "loyaltyAdmin.operationCOMMIT": "Izlietojums",
  "loyaltyAdmin.operationRELEASE": "Rezervācijas atcelšana",
  "loyaltyAdmin.operationREVERSE_CREDIT": "Uzkrājuma atcelšana",
  "loyaltyAdmin.operationREFUND_SPEND": "Punktu atmaksa",
  "loyaltyAdmin.operationEXPIRE": "Derīguma beigas",
  "loyaltyAdmin.coreCategoriesTitle": "Core lojalitātes kategorijas",
  "loyaltyAdmin.categoryReadOnlyNotice": "Tikai apskate. Kategoriju maiņa un karšu izdošana caur Core vēl nav pieejama.",
  "loyaltyAdmin.issuerCategoryNotice": "Šeit redzamas tikai šī tirgotāja kategorijas.",
  "loyaltyAdmin.currency": "Valūta",
  "loyaltyAdmin.giftKind": "Dāvanu karte",
  "loyaltyAdmin.accrualRate": "Uzkrājums, %",
  "loyaltyAdmin.discountRate": "Atlaide, %",
  "loyaltyAdmin.giftLifetime": "Iegādātās vērtības termiņš, mēneši",
  "loyaltyAdmin.notConfigured": "Jāpārbauda iestatījums",
  "loyaltyAdmin.exclusionReferenceNotice": "Redzams izņēmumu skaits; produktu kategoriju nosaukumi jāsalīdzina ar katalogu.",
  "loyaltyAdmin.moreHistory": "Ielādēt agrākās versijas",
  "loyaltyAdmin.transferTitle": "Karšu saraksta imports",
  "loyaltyAdmin.transferExportPairedUnavailable": "Eksports pašlaik nav pieejams: šim īpašniekam ir kartes ar divām kategorijām. Pašreizējais faila formāts neiekļautu otro kategoriju un tās atlikumu.",
  "loyaltyAdmin.transferExportTitle": "Aktuālo karšu un atlikumu eksports",
  "loyaltyAdmin.transferExportNotice": "Izveido finanšu lomai pieejamu momentuzņēmumu ar pierādāmiem precīziem karšu kodiem, visām kategoriju versijām un atlikumu porcijām, atsevišķām Gift un promo saistībām un tirgotāju uzkrājumu/izlietojuma pārskatu. Eksports tiek apturēts, ja precīzu kodu vai gaidošu atlikumu nevar apstiprināt.",
  "loyaltyAdmin.transferExportXlsx": "Eksportēt aktuālu XLSX",
  "loyaltyAdmin.transferExportCsv": "Eksportēt aktuālu CSV",
  "loyaltyAdmin.transferExportPreparing": "Tiek gatavots īpašnieka momentuzņēmums…",
  "loyaltyAdmin.transferExportReady": "Pārbaudītais momentuzņēmums ir lejupielādēts.",
  "loyaltyAdmin.transferNotice": "Tikai priekšskatījuma pārbaude. Kartes un atlikumi netiek mainīti; apstiprināts imports vēl nav pieejams.",
  "loyaltyAdmin.transferTemplateNotice": "Lejupielādējiet un aizpildiet veidni. Aizstājiet visus piemēra kodus, atlikumus, datumu un kategoriju noteikumus ar saviem datiem.",
  "loyaltyAdmin.transferTemplateXlsx": "XLSX veidne",
  "loyaltyAdmin.transferTemplateCsv": "CSV veidne (ZIP)",
  "loyaltyAdmin.transferFormat": "Failu formāts",
  "loyaltyAdmin.transferFileLimit": "Kopā līdz 2 MB. CSV vajadzīgi visi trīs faili; arī tad, ja daļu nav, to tabulā jābūt galvenei.",
  "loyaltyAdmin.transferCheck": "Pārbaudīt failus",
  "loyaltyAdmin.transferSave": "Saglabāt pakotni",
  "loyaltyAdmin.transferOpeningCheck": "Pārbaudīt sākuma atlikumus",
  "loyaltyAdmin.transferOpeningChecked": "Sākuma atlikumu aprēķins pārbaudīts",
  "loyaltyAdmin.transferOpeningBlocked": "Sākuma atlikumu aprēķins bloķēts",
  "loyaltyAdmin.transferOpeningAt": "Aprēķina laiks",
  "loyaltyAdmin.transferOpeningNotice": "Tikai aprēķins. Vēl nepieciešama atbilstību pārbaude, avota identifikatoru pieņemšana, termiņu saskaņošana un apstiprināta piemērošana žurnālā. Kartes un atlikumi nav mainīti.",
  "loyaltyAdmin.transferOpeningSource": "Momentuzņēmuma atlikums, mazākās vienības",
  "loyaltyAdmin.transferOpeningExpired": "Kopš momentuzņēmuma dzēsts, mazākās vienības",
  "loyaltyAdmin.transferOpeningProjected": "Aprēķinātais atlikums, mazākās vienības",
  "loyaltyAdmin.transferFutureSnapshot": "Momentuzņēmuma datums ir nākotnē. Pārbaudiet sākotnējo datumu un laiku.",
  "loyaltyAdmin.transferSaveNotice": "Saglabāt šifrētu avota momentuzņēmumu vēlākai salīdzināšanai. Tas neveido kartes, neapstiprina importu un nemaina atlikumus.",
  "loyaltyAdmin.transferSaved": "Pakotne saglabāta; imports nav piemērots. Atsauce",
  "loyaltyAdmin.transferDraftConflict": "Šis saglabāšanas pieprasījums jau attiecas uz citiem datiem. Pārbaudiet failus vēlreiz pirms jaunas pakotnes izveides.",
  "loyaltyAdmin.transferValid": "Failu pārbaude sekmīga",
  "loyaltyAdmin.transferInvalid": "Pārbaudiet failus un saņēmēja valūtu.",
  "loyaltyAdmin.transferErrors": "Kļūdas",
  "loyaltyAdmin.transferWarnings": "Jāsaskaņo pirms importa",
  "loyaltyAdmin.transferMinorBalance": "Atlikums (valūtas mazākās vienības)",
  "loyaltyAdmin.transferSection_cards": "Kartes",
  "loyaltyAdmin.transferSection_categories": "Kategoriju versijas",
  "loyaltyAdmin.transferSection_lots": "Daļas",
  "loyaltyAdmin.transferSection_package": "Pakotne",
  "loyaltyAdmin.transferRow": "Rinda",
  "loyaltyAdmin.transferDuplicate": "Atkārtota karte, kods, kategorijas versija vai daļa.",
  "loyaltyAdmin.transferBalanceMismatch": "Daļu summa un parāds neatbilst atlikumam.",
  "loyaltyAdmin.transferMapping": "Pirms importa apstipriniet kartes un kategorijas piesaisti un versiju.",
  "loyaltyAdmin.transferOpening": "Saskaņojiet sākuma atlikumu un derīguma politiku.",
  "loyaltyAdmin.transferReservations": "Pirms importa pārbaudiet nepabeigtās rezervācijas.",
  "loyaltyAdmin.transferGift": "Iegādātās dāvanu vērtības piemērošana vēl nav pieejama.",
  "loyaltyAdmin.transferCheckRow": "Pārbaudiet rindas laukus, tipus un sākotnējos datumus.",
  "loyaltyAdmin.transferFile_cards": "Karšu CSV",
  "loyaltyAdmin.transferFile_categories": "Kategoriju versiju CSV",
  "loyaltyAdmin.transferFile_lots": "Daļu CSV",
  "loyaltyAdmin.transferFile_workbook": "XLSX darbgrāmata",
  "loyaltyAdmin.transferSessionChanged": "Sesija ir mainījusies. Pārlādējiet lapu un atlasiet failus vēlreiz.",
  "loyaltyAdmin.transferApplyTitle": "Apstiprināt importu",
  "loyaltyAdmin.transferApplyNotice": "Izveido Coop kartes un novērotos sākuma atlikumus, arī dāvanu vērtību ar zināmām sākotnējām daļām un termiņiem. Syrve un finanšu avots nemainās. Nezināmi termiņi, rezervācijas un preču kategorijas jāsaskaņo.",
  "loyaltyAdmin.transferApplyPending": "Atjaunot iepriekšējo pieprasījumu",
  "loyaltyAdmin.transferApplyIssuer": "Visām kartēm ir viens izdevējs; piešķirt tām izvēlēto tirgotāju.",
  "loyaltyAdmin.transferApplyBalances": "Esmu pārbaudījis atlikumus, parādu un sākotnējos termiņus.",
  "loyaltyAdmin.transferApply": "Importēt",
  "loyaltyAdmin.transferApplyRetry": "Atkārtot sākotnējo importu",
  "loyaltyAdmin.transferApplyCancel": "Atcelt neizpildītu importu",
  "loyaltyAdmin.transferApplied": "Kartes importētas",
  "loyaltyAdmin.transferApplyAborted": "Imports atcelts, neizveidojot atlikumus.",
  "loyaltyAdmin.transferApplyLookup": "Atrast importētās kartes",
  "loyaltyAdmin.transferApplyDone": "Pabeigt",
  "loyaltyAdmin.transferApplyStorage": "Neizdevās saglabāt atjaunošanas datus. Jauns pieprasījums netika nosūtīts.",
  "loyaltyAdmin.transferApplyUnknown": "Rezultāts nav zināms. Atkārtojiet sākotnējo pieprasījumu vai atceliet to. Pabeigts imports netiks atsaukts.",
  "loyaltyAdmin.transferApplyMappingBlocked": "Saskaņojiet izdevējus vai preču kategorijas. Pirms pakotnes labošanas atceliet šo pieprasījumu.",
  "loyaltyAdmin.transferApplyConflict": "Avota identitāte vai kartes kods jau pastāv. Saskaņojiet sākotnējo importu bez atkārtota atlikuma.",
  "loyaltyAdmin.transferApplyUnsupported": "Pirms importa saskaņojiet noteikumus, termiņus, rezervācijas vai preču kategorijas.",
  "loyaltyAdmin.operationIMPORT_OPENING": "Importētais sākuma atlikums",
  "loyaltyAdmin.transferApplyCategoryLimit": "Izvēlētais tirgotājs atbalsta līdz 500 kategorijām. Atceliet pieprasījumu un saskaņojiet pakotni ar esošajām kategorijām.",
  "loyaltyAdmin.tasks": "Darbības",
  "loyaltyAdmin.back": "Atpakaļ",
  "loyaltyAdmin.taskfind": "Atrast karti",
  "loyaltyAdmin.taskcatalog": "Karšu katalogs",
  "loyaltyAdmin.taskissue": "Izsniegt tukšu karti",
  "loyaltyAdmin.taskcategories": "Kategorijas",
  "loyaltyAdmin.taskgift": "Pārdot / papildināt Gift",
  "loyaltyAdmin.tasksource": "Programmas iestatījumi",
  "loyaltyAdmin.openCard": "Atvērt karti",
  "loyaltyAdmin.loading": "Ielādē…",
  "loyaltyAdmin.balanceRead": "Atlikums atjaunināts",
  "loyaltyAdmin.balanceDetails": "Atlikuma informācija",
  "loyaltyAdmin.creditUnavailable": "Manuāla ieskaitīšana pagaidām nav pieejama. Sazinieties ar programmas administratoru.",
  "loyaltyAdmin.issuerRequired": "Manuāla ieskaitīšana pieejama pie kartes izdevēja.",
  "loyaltyAdmin.resumeCredit": "Turpināt ieskaitīšanu",
  "loyaltyAdmin.checkoutpoints": "punkti",
  "loyaltyAdmin.checkoutcardBalance": "Kartes atlikums",
  "loyaltyAdmin.checkoutavailableCardBalance": "Kartē pieejams",
  "loyaltyAdmin.checkoutreservedCardBalance": "Rezervēts",
  "loyaltyAdmin.checkoutownerCardBalance": "Īpašnieka kartes atlikums",
  "loyaltyAdmin.checkoutpartCalculation": "Izvēlētās daļas aprēķins",
  "loyaltyAdmin.checkoutmaximumPart": "Šīs daļas maksimums",
  "loyaltyAdmin.checkoutselectedValue": "Izvēlētā kartes summa",
  "loyaltyAdmin.checkoutavailableAfter": "Pieejams pēc maksājuma",
  "loyaltyAdmin.checkoutexpectedAccrual": "Paredzētie punkti",
  "loyaltyAdmin.checkoutpriceDiscount": "Kartes atlaide",
  "loyaltyAdmin.checkoutgiftUsed": "Izmantots Gift",
  "loyaltyAdmin.checkoutpromoUsed": "Izmantotie bonusi",
  "loyaltyAdmin.checkoutpointsAccrued": "Ieskaitītie punkti",
  "loyaltyAdmin.checkoutconfirmedPayment": "Apstiprināts kartes maksājums",
  "loyaltyAdmin.checkoutpaymentConfirmed": "Kartes maksājums apstiprināts.",
  "loyaltyAdmin.checkoutcardUsed": "Izmantotā kartes summa",
  "loyaltyAdmin.checkoutrecentHistory": "Pēdējās kartes darbības",
  "loyaltyAdmin.checkoutnoOperations": "Kartes darbību vēl nav.",
  "loyaltyAdmin.checkoutlookupCode": "Kartes kods vai QR",
  "loyaltyAdmin.checkoutreadCard": "Atrast karti",
  "loyaltyAdmin.checkoutwithoutCard": "Turpināt bez kartes",
  "loyaltyAdmin.checkoutloyaltyCard": "Lojalitātes karte",
  "loyaltyAdmin.checkoutloyaltyCash": "Karte un skaidra nauda",
  "loyaltyAdmin.checkoutscanCardCheckout": "Skenēt karti",
  "loyaltyAdmin.checkoutnone": "Neizmantot punktus",
  "loyaltyAdmin.checkoutmaximum": "Izmantot maksimumu",
  "loyaltyAdmin.checkoutcustom": "Izvēlēties punktus",
  "loyaltyAdmin.checkoutamount": "Izmantojamie punkti",
  "loyaltyAdmin.checkoutmoney": "Samaksa par precēm",
  "loyaltyAdmin.checkoutpointsDiscount": "Samaksa ar punktiem",
  "loyaltyAdmin.checkoutprepayment": "Gift priekšapmaksa",
  "loyaltyAdmin.checkoutgiftTitle": "Gift maksājums",
  "loyaltyAdmin.checkoutgiftNone": "Neizmantot Gift",
  "loyaltyAdmin.checkoutgiftMaximum": "Izmantot Gift maksimumu",
  "loyaltyAdmin.checkoutgiftCustom": "Izvēlēties Gift summu",
  "loyaltyAdmin.checkoutpairedTitle": "Gift un bonusi",
  "loyaltyAdmin.checkoutpairedNone": "Neizmantot karti",
  "loyaltyAdmin.checkoutpairedMaximum": "Izmantot kartes maksimumu",
  "loyaltyAdmin.checkoutpairedCustom": "Izvēlēties summu",
  "loyaltyAdmin.checkoutconfirmGuest": "Apstiprināt un atvērt maksājumu",
  "loyaltyAdmin.checkoutfailedGuest": "Rezultāts nav apstiprināts. Pārbaudiet saglabāto maksājumu pirms jauna maksājuma.",
  "loyaltyAdmin.checkoutexpired": "Aprēķins beidzies. Izvēlieties punktu summu vēlreiz.",
  "loyaltyAdmin.checkoutgiftExpired": "Aprēķins beidzies. Izvēlieties Gift summu vēlreiz.",
  "loyaltyAdmin.checkoutpairedExpired": "Aprēķins beidzies. Izvēlieties summu vēlreiz.",
  "loyaltyAdmin.checkoutcashTitle": "Maksājums ar karti",
  "loyaltyAdmin.checkoutcashGoods": "Skaidra nauda par precēm",
  "loyaltyAdmin.checkoutcashConfirm": "Apstiprināt saņemto naudu",
  "loyaltyAdmin.checkoutcashFailed": "Maksājums nav apstiprināts. Pārbaudiet saglabāto mēģinājumu pirms naudas saņemšanas.",
  "loyaltyAdmin.checkoutguestPending": "Saglabātais maksājums jāpārbauda. Uzrādiet to pašu karti. Noildze to neatceļ.",
  "loyaltyAdmin.checkoutcashPending": "Kartes un skaidras naudas maksājums gaida apstiprinājumu. Uzrādiet to pašu karti un pārbaudiet rezultātu.",
  "loyaltyAdmin.checkoutresumeGuest": "Turpināt saglabāto maksājumu",
  "loyaltyAdmin.checkoutresumeCash": "Pārbaudīt iepriekšējo maksājumu",
  "loyaltyAdmin.checkoutcancelGuest": "Atcelt nesākto apstiprinājumu",
  "loyaltyAdmin.checkoutcancelCash": "Atcelt nesākto kartes apstiprinājumu",
  "loyaltyAdmin.checkoutzeroGuest": "Apstiprināt bez piemaksas",
  "loyaltyAdmin.checkoutpaymentUnavailable": "Maksājums nav pieejams.",
  "loyaltyAdmin.checkoutsavedPaymentUnreadable": "Saglabāto maksājumu nevar nolasīt. Pirms atkārtotas apmaksas sazinieties ar darbinieku.",
  "loyaltyAdmin.checkoutrecoveryStorageUnavailable": "Maksājuma atkopšanas krātuve nav pieejama. Pirms atkārtotas apmaksas sazinieties ar darbinieku.",
  "loyaltyAdmin.checkoutremainderUnconfirmed": "Maksājuma atlikums nav apstiprināts.",
  "loyaltyAdmin.checkoutcardBlocked": "Šī karte ir bloķēta.",
  "loyaltyAdmin.checkoutpaymentPendingResolution": "Maksājums vēl nav pabeigts. Atkārtoti pārbaudiet saglabāto maksājumu.",
  "loyaltyAdmin.checkoutcancellationUnconfirmed": "Atcelšana nav apstiprināta.",
  "loyaltyAdmin.checkouttipRequiresPayment": "Noņemiet dzeramnaudu, lai apstiprinātu bez papildu maksājuma, vai izmantojiet mazāk punktu.",
  "loyaltyAdmin.checkoutcalculationChanged": "Aprēķins ir mainījies.",
  "loyaltyAdmin.checkoutgiftAmountCurrency": "Gift summa ({currency})",
  "loyaltyAdmin.checkoutcardAmountCurrency": "Kartes summa ({currency})",
  "loyaltyAdmin.checkoutworking": "Notiek apstrāde…",
  "loyaltyAdmin.checkouttipLabel": "Dzeramnauda",
  "loyaltyAdmin.checkoutcompleteGuestCount": "Pirms apmaksas norādiet viesu skaitu.",
  "loyaltyAdmin.checkoutinvalidPaymentAmount": "Aprēķinātā maksājuma summa nav derīga.",
  "loyaltyAdmin.checkoutcalculationChangedRetry": "Aprēķins ir mainījies. Vēlreiz izvēlieties punktu summu.",
  "loyaltyAdmin.checkouthistoryImportOpening": "Importēts sākuma atlikums",
  "loyaltyAdmin.checkouthistoryCredit": "Vērtība pievienota",
  "loyaltyAdmin.checkouthistoryReserve": "Vērtība rezervēta",
  "loyaltyAdmin.checkouthistoryRelease": "Rezervācija atcelta",
  "loyaltyAdmin.checkouthistoryPayment": "Maksājums",
  "loyaltyAdmin.checkouthistoryPaymentPending": "Maksājums gaida apstiprinājumu",
  "loyaltyAdmin.checkouthistoryPaymentCanceled": "Maksājums atcelts",
  "loyaltyAdmin.checkouthistoryPaymentReturned": "Maksājuma vērtība atgriezta",
  "loyaltyAdmin.checkouthistoryAccrualReversed": "Uzkrājums atcelts",
  "loyaltyAdmin.checkouthistoryExpired": "Vērtības termiņš beidzies",
  "loyaltyAdmin.checkouthistoryOperation": "Kartes darbība",
  "loyaltyAdmin.checkoutzeroCash": "Apstiprināt bez skaidras naudas par precēm",
  "loyaltyAdmin.checkoutchoosePart": "Izvēlieties pieejamo rēķina daļu šai kartei.",
  "loyaltyAdmin.checkoutchooseCashPart": "Izvēlieties summu atlikušā rēķina robežās.",
  "loyaltyAdmin.checkoutattached": "Karte piesaistīta pašreizējam apmeklējumam.",
  "loyaltyAdmin.giftPresentSelectedCard": "Lai turpinātu, uzrādiet izvēlēto karti.",
  "loyaltyAdmin.giftDifferentCard": "Šī ir cita karte. Uzrādiet izvēlēto karti.",
  "loyaltyAdmin.ownerReportTitle": "Īpašnieka pārskats",
  "loyaltyAdmin.ownerReportNotice": "Pārbaudiet pašreizējās Gift un Promo saistības un karšu darbību periodā. Beigu datums ir iekļauts.",
  "loyaltyAdmin.ownerReportFrom": "No",
  "loyaltyAdmin.ownerReportTo": "Līdz",
  "loyaltyAdmin.ownerReportMerchant": "Darbības tirgotājs",
  "loyaltyAdmin.ownerReportAllMerchants": "Visi īpašnieka tirgotāji",
  "loyaltyAdmin.ownerReportShow": "Rādīt pārskatu",
  "loyaltyAdmin.ownerReportInvalidPeriod": "Izvēlieties derīgu pārskata periodu.",
  "loyaltyAdmin.ownerReportResult": "Pārskata rezultāts",
  "loyaltyAdmin.ownerReportAsOf": "Saistības uz",
  "loyaltyAdmin.ownerReportObligations": "Pašreizējās saistības",
  "loyaltyAdmin.ownerReportActivity": "Darbība izvēlētajā periodā",
  "loyaltyAdmin.ownerReportEmpty": "Šai atlasei nav rindu.",
  "loyaltyAdmin.ownerReportOutstanding": "Atlikums",
  "loyaltyAdmin.ownerReportAvailable": "Pieejams",
  "loyaltyAdmin.ownerReportReserved": "Rezervēts",
  "loyaltyAdmin.ownerReportDebt": "Parāds",
  "loyaltyAdmin.ownerReportCredited": "Ieskaitīts",
  "loyaltyAdmin.ownerReportReversed": "Ieskaitījums atcelts",
  "loyaltyAdmin.ownerReportRedeemed": "Izlietots",
  "loyaltyAdmin.ownerReportRefunded": "Izlietojums atmaksāts",
  "loyaltyAdmin.ownerReportNet": "Neto kustība",
  "loyaltyAdmin.ownerReportMinorUnits": "Summas ir norādītas valūtas mazākajās vienībās.",
};
